import React from 'react';

import { PURCHASE_IMPORT_SHIPMENT_PERMISSION } from 'pages/PurchaseImportShipments/utils/constants';

const PurchaseImportShipmentListPage = React.lazy(() => import('pages/PurchaseImportShipments/pages/ListPage'));
const PurchaseImportShipmentAddPage = React.lazy(() => import('pages/PurchaseImportShipments/pages/AddPage'));

const purchaseImportShipmentRoutes = [
  {
    path: '/purchase-import-shipments',
    exact: true,
    name: 'Hồ sơ nhập khẩu',
    function: PURCHASE_IMPORT_SHIPMENT_PERMISSION.VIEW,
    component: PurchaseImportShipmentListPage,
  },
  {
    path: '/purchase-import-shipments/add',
    exact: true,
    name: 'Thêm hồ sơ nhập khẩu',
    function: PURCHASE_IMPORT_SHIPMENT_PERMISSION.ADD,
    component: PurchaseImportShipmentAddPage,
  },
  {
    path: '/purchase-import-shipments/edit/:id',
    exact: true,
    name: 'Chỉnh sửa hồ sơ nhập khẩu',
    function: PURCHASE_IMPORT_SHIPMENT_PERMISSION.EDIT,
    component: PurchaseImportShipmentAddPage,
  },
  {
    path: '/purchase-import-shipments/detail/:id',
    exact: true,
    name: 'Chi tiết hồ sơ nhập khẩu',
    function: PURCHASE_IMPORT_SHIPMENT_PERMISSION.VIEW,
    component: PurchaseImportShipmentAddPage,
  },
];

export default purchaseImportShipmentRoutes;
